

















import { computed, defineComponent } from "@vue/composition-api";
import { AvailabilityIntervalType } from "@scrile/api-provider/dist/projects/scrileConnect/UserAvailabilityProvider";
import { $t } from "@/lib/i18nHelpers";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "AppointmentsSettingsList",
  components: {
    PageTitle,
    BasePage,
  },
  props: {
    offline: { type: Boolean, default: false },
  },
  setup(props) {
    const menuList = computed(() => {
      return [
        {
          label: $t("Online meetings"),
          name: "onlineMeetings",
          to: { name: "appointmentsSettingsEdit", query: { type: AvailabilityIntervalType.ONLINE } },
        },
        ...(props.offline
          ? [
              {
                label: $t("Offline meetings"),
                name: "offlineMeetings",
                to: { name: "appointmentsSettingsEdit", query: { type: AvailabilityIntervalType.TOUR_GUIDE } },
              },
            ]
          : []),
      ];
    });

    return { menuList };
  },
});
